import { Panel } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TextField } from "../../../components/TextField";
import Divider from "../../../components/menu/Divider";
import { Score } from "../../../components/Score";
import { ScoreBarChart } from "../../../components/ScoreBarChart";
import { Image } from "primereact/image";
import { openPDF } from "../../../utils/open_pdf_base64";
import pdfImagem from '../../../assets/pdfImagens.png';

export default function AutoLaudo({
  data,
  title
}: {
  data: any
  title: any
}) {
  const renderField = (label: string, value?: string) => {
    if (!value) return null;
    return <TextField label={label} value={value} />;
  };

  const getValueScore = (value: string) => {
    if (value === 'A') {
      return '950';
    }
    if (value === 'B') {
      return '750';
    }

    if (value === 'C') {
      return '550';
    }

    if (value === 'D') {
      return '350';
    }

    if (value === 'E') {
      return '150';
    }
    return '0';
  }

  const topMarkers = [
    '0', '10', '40', '60', '80', '100'
  ];

  const bottomLabels = [
    "Baixa",
    "Média",
    "Alta"
  ];

  const getRange = (pontuacao: number) => {

    if (pontuacao >= 400 && pontuacao < 500) {
      return 'REGULAR'
    }

    if (pontuacao >= 500 && pontuacao < 600) {
      return 'BOM'
    }
    if (pontuacao >= 600) {
      return 'OTIMO'
    }

    return 'RUIM'
  }

  return (
    <Panel header={title} style={{ width: '98%' }}>

      <Panel header="Resumo do veículo">
        <section style={{ display: "grid", gridTemplateColumns: "1fr 2fr 2fr" }}>
          {data?.BIN_NACIONAL ? (
            <div>
              {data?.BIN_NACIONAL?.LOGO_FABRICANTE?.IMAGEM_BASE64 && (
                <img src={'data:image/jpeg;base64, ' + data?.BIN_NACIONAL?.LOGO_FABRICANTE?.IMAGEM_BASE64} alt="Logo fabricante"></img>
              )}
            </div>
          ) : (
            <div>
              {data?.BIN_ESTADUAL?.LOGO_FABRICANTE?.IMAGEM_BASE64 && (
                <img src={'data:image/jpeg;base64, ' + data?.BIN_ESTADUAL?.LOGO_FABRICANTE?.IMAGEM_BASE64} alt="Logo fabricante"></img>
              )}
            </div>
          )}
          {data?.BIN_NACIONAL ? (
            <div>
              {renderField("Marca/Modelo", data?.BIN_NACIONAL?.MARCA_MODELO)}
              {renderField("Ano Fabricação/Modelo", data?.BIN_NACIONAL?.ANO_FABRICACAO + '/' + data?.BIN_NACIONAL?.ANO_MODELO)}
              {renderField("Cor", data?.BIN_NACIONAL?.COR_VEICULO)}
              {renderField("Número motor", data?.BIN_NACIONAL?.NUMERO_MOTOR)}
            </div>
          ) :
            (
              <div>
                {renderField("Marca/Modelo", data?.BIN_ESTADUAL?.MARCA_MODELO)}
                {renderField("Ano Fabricação/Modelo", data?.BIN_ESTADUAL?.ANO_FABRICACAO + '/' + data?.BIN_ESTADUAL?.ANO_MODELO)}
                {renderField("Cor", data?.BIN_ESTADUAL?.COR_VEICULO)}
                {renderField("Número motor", data?.BIN_ESTADUAL?.NUMERO_MOTOR)}
              </div>
            )}
          {data?.BIN_NACIONAL ? (
            <div>
              {renderField("Placa", data?.BIN_NACIONAL?.PLACA)}
              {renderField("Chassi", data?.BIN_NACIONAL?.CHASSI)}
              {renderField("Combustível", data?.BIN_NACIONAL?.COMBUSTIVEL)}
            </div>
          ) :
            (
              <div>
                {renderField("Placa", data?.BIN_ESTADUAL?.PLACA)}
                {renderField("Chassi", data?.BIN_ESTADUAL?.CHASSI)}
                {renderField("Combustível", data?.BIN_ESTADUAL?.COMBUSTIVEL)}
              </div>
            )}
        </section>
      </Panel>
      <br></br>
      {data?.ANALISE_KILOMETRAGEM && (
        <Panel header="Análise Quilometragem">
          <h5>Estimativa</h5>
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>

            <div>
              {renderField("KM Baixa", data?.ANALISE_KILOMETRAGEM?.ESTIMATIVA?.BAIXA)}
            </div>
            <div>
              {renderField("KM Média", data?.ANALISE_KILOMETRAGEM?.ESTIMATIVA?.MEDIA)}
            </div>
            <div>
              {renderField("KM Alta", data?.ANALISE_KILOMETRAGEM?.ESTIMATIVA?.ALTA)}
            </div>
          </section>
        </Panel>
      )}
      <br></br>
      {data?.RENAJUD && (
        <Panel header="Renajud">
          <DataTable value={data?.RENAJUD?.OCORRENCIAS}>
            <Column field="DATA" header="Data"></Column>
            <Column field="CODIGO_JUDICIAL" header="Código"></Column>
            <Column field="MARCA_MODELO" header="Marca/modelo"></Column>
            <Column field="PROCESSO" header="Processo"></Column>
            <Column body={(item: any) => item.ANO_DE_FABRICACAO + '/' + item.ANO_MODELO} header="Ano Fabricação/modelo"></Column>
            <Column field="PLACA" header="Placa"></Column>
            <Column field="RENAVAM" header="Renavam"></Column>
            <Column field="RESTRICOES" header="Restrição"></Column>
            <Column field="TRIBUNAL" header="Tribunal"></Column>
            <Column field="TIPO_BLOQUEIO" header="Tipo bloqueio"></Column>
          </DataTable>
        </Panel>
      )}
      <br></br>
      {data?.RENAINF && (
        <Panel header="Renainf">
          <DataTable value={data?.RENAINF?.OCORRENCIAS}>
            <Column field="DATA_INFRACAO" header="Data"></Column>
            <Column field="INFRACAO" header="Infração"></Column>
            <Column field="AUTO_INFRACAO" header="Auto Infração"></Column>
            <Column field="ORGAO_ATUADOR" header="Órgão"></Column>
            <Column field="DETALHES.DADOS_NOTIFICACAO.VALOR_INFRACAO" header="Valor"></Column>
          </DataTable>
        </Panel>
      )}
      <br></br>
      <Panel header="Alertas">
        <DataTable value={data?.ALERTAS?.OCORRENCIAS}>
          <Column field="DESCRICAO" header="Descrição"></Column>
          <Column field="MENSAGEM" header="Mensagem"></Column>
          <Column field="SEVERIDADE" header="Serveridade"></Column>
        </DataTable>
      </Panel>
      <br></br>
      {data?.CALCULO_VALORIZACAO && (
        <Panel header="Calculo valorização">
          {data?.CALCULO_VALORIZACAO?.CALCULOS?.map((item: any) => (
            <div>
              <DataTable value={item.VALORES}>
                <Column field="MES" header="Mês"></Column>
                <Column field="ANO" header="Ano"></Column>
                <Column field="VALOR_INTEGRAL" header="Valor"></Column>
                <Column field="VALOR_DIFERENCA" header="Diferença"></Column>
                <Column field="PORCENTAGEM_DIFERENCA" header="Percentual diferença"></Column>
              </DataTable>
              <br></br>
            </div>
          ))}

        </Panel>
      )}
      <br></br>
      {data?.PROPRIETARIO_ATUAL_VEICULO && (
        <Panel header="Proprietário Atual">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>

            <div>
              {renderField("Marca/Modelo", data?.PROPRIETARIO_ATUAL_VEICULO?.MARCA_MODELO)}
              {renderField("Ano Fabricação/Modelo", data?.PROPRIETARIO_ATUAL_VEICULO?.ANO_FABRICACAO + '/' + data?.PROPRIETARIO_ATUAL_VEICULO?.ANO_MODELO)}
              {renderField("Cor", data?.PROPRIETARIO_ATUAL_VEICULO?.COR_VEICULO)}
              {renderField("Número motor", data?.PROPRIETARIO_ATUAL_VEICULO?.MOTOR)}
              {renderField("Data", data?.PROPRIETARIO_ATUAL_VEICULO?.DATA_ATUALIZACAO)}
              <h4>Proprietário</h4>
              {renderField("Documento", data?.PROPRIETARIO_ATUAL_VEICULO?.PROPRIETARIO_DOCUMENTO)}
              {renderField("Nome", data?.PROPRIETARIO_ATUAL_VEICULO?.PROPRIETARIO_NOME)}
            </div>
            <div>
              {renderField("Placa", data?.PROPRIETARIO_ATUAL_VEICULO?.PLACA)}
              {renderField("Chassi", data?.PROPRIETARIO_ATUAL_VEICULO?.CHASSI)}
              {renderField("Combustível", data?.PROPRIETARIO_ATUAL_VEICULO?.COMBUSTIVEL)}
              {renderField("Município", data?.PROPRIETARIO_ATUAL_VEICULO?.MUNICIPIO)}
              {renderField("UF", data?.PROPRIETARIO_ATUAL_VEICULO?.UF)}
            </div>
          </section>
        </Panel>
      )}
      <br></br>
      <Panel header="Informação do veículo">
        <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
          {data?.BIN_NACIONAL && (
            <div>
              <h3>Informação Nacional</h3>
              {renderField("Marca/Modelo", data?.BIN_NACIONAL?.MARCA_MODELO)}
              {renderField("Ano Fabricação/Modelo", data?.BIN_NACIONAL?.ANO_FABRICACAO + '/' + data?.BIN_NACIONAL?.ANO_MODELO)}
              {renderField("Categoria", data?.BIN_NACIONAL?.CATEGORIA_VEICULO)}
              {renderField("Tipo veículo", data?.BIN_NACIONAL?.TIPO_VEICULO)}
              {renderField("Placa", data?.BIN_NACIONAL?.PLACA)}
              {renderField("Renavam", data?.BIN_NACIONAL?.RENAVAM)}
              {renderField("Chassi", data?.BIN_NACIONAL?.CHASSI)}
              {renderField("Situação", data?.BIN_NACIONAL?.SITUACAO)}
              {renderField("Cambio", data?.BIN_NACIONAL?.CAIXA_CAMBIO)}
              {renderField("Capacidade de carga", data?.BIN_NACIONAL?.CAPACIDADE_CARGA)}
              {renderField("Cilindradas", data?.BIN_NACIONAL?.CILINDRADA)}
              {renderField("CMT", data?.BIN_NACIONAL?.CMT)}
              {renderField("Combustível", data?.BIN_NACIONAL?.COMBUSTIVEL)}
              {renderField("Cor", data?.BIN_NACIONAL?.COR_VEICULO)}
              {renderField("Espécie", data?.BIN_NACIONAL?.ESPECIE_VEICULO)}
              {renderField("Emplacamento", data?.BIN_NACIONAL?.DATA_EMPLACAMENTO)}
              {renderField("Município", data?.BIN_NACIONAL?.MUNICIPIO)}
              {renderField("UF", data?.BIN_NACIONAL?.UF)}
              {renderField("N. Carroceria", data?.BIN_NACIONAL?.NUMERO_CARROCERIA)}
              {renderField("Número DI", data?.BIN_NACIONAL?.NUMERO_DI)}
              {renderField("Data DI", data?.BIN_NACIONAL?.DATA_REGISTRO_DI)}
              {renderField("Número Eixo Auxiliar", data?.BIN_NACIONAL?.NUMERO_EIXO_AUXILIAR)}
              {renderField("Número Eixo Traseiro", data?.BIN_NACIONAL?.NUMERO_EIXO_TRASEIRO)}
              {renderField("Quantidade Eixos", data?.BIN_NACIONAL?.NUMERO_EIXOS)}
              {renderField("Número motor", data?.BIN_NACIONAL?.NUMERO_MOTOR)}
              {renderField("PBT", data?.BIN_NACIONAL?.PBT)}
              {renderField("Potência", data?.BIN_NACIONAL?.POTENCIA_VEICULO)}
              {renderField("Procedência", data?.BIN_NACIONAL?.PROCEDENCIA)}
              {renderField("Quantidade passageiros", data?.BIN_NACIONAL?.QUANTIDADE_PASSAGEIROS)}
              {renderField("Situação chassi", data?.BIN_NACIONAL?.SITUACAO_CHASSI)}
              {renderField("Tipo carroceria", data?.BIN_NACIONAL?.TIPO_CARROCERIA)}
              {renderField("Tipo Doc. faturado", data?.BIN_NACIONAL?.TIPO_DOCUMENTO_FATURADO)}
              {renderField("Tipo Doc. importador", data?.BIN_NACIONAL?.TIPO_DOCUMENTO_IMPORTADOR)}
              {renderField("Número importador", data?.BIN_NACIONAL?.NUMERO_IDENTIFICACAO_IMPORTADOR)}
              {renderField("Tipo Operação importação", data?.BIN_NACIONAL?.TIPO_OPERACAO_IMPORTACAO_VEICULO)}
              {renderField("Montagem", data?.BIN_NACIONAL?.TIPO_MONTAGEM)}
              {renderField("Número Faturado", data?.BIN_NACIONAL?.NUMERO_IDENTIFICACAO_FATURADO)}
              {renderField("UF Faturamento", data?.BIN_NACIONAL?.UF_FATURAMENTO)}
              {renderField("Data limite restrição trib.", data?.BIN_NACIONAL?.DATA_LIMITE_RESTRICAO_TRIBUTARIA)}
              {renderField("Data atualização", data?.BIN_NACIONAL?.DATA_ATUALIZACAO)}
              {renderField("Código órgão SRF", data?.BIN_NACIONAL?.CODIGO_DO_ORGAO_SRF)}
              {renderField("Data emissão CRLV", data?.BIN_NACIONAL?.DATA_EMISSAO_CRLV)}
              {renderField("Data Emissão Último CRV", data?.BIN_NACIONAL?.DATA_EMISSAO_ULTIMO_CRV)}
              <Divider></Divider>
              <h5>Restrições Nacional</h5>
              {data?.BIN_NACIONAL?.RESTRICOES?.MENSAGENS_RESTRICOES && data?.BIN_NACIONAL?.RESTRICOES?.MENSAGENS_RESTRICOES.length > 0 && (
                <div>
                  {data?.BIN_NACIONAL?.RESTRICOES?.MENSAGENS_RESTRICOES.map((item: any) => (
                    renderField("Restrição", item.MENSAGEM)
                  ))}
                </div>
              )}
              {data?.BIN_NACIONAL?.PROPRIETARIO && (
                <div>
                  <h5>Proprietário</h5>
                  {renderField("CPF/CNPJ", data?.BIN_NACIONAL?.PROPRIETARIO?.DOCUMENTO)}
                  {renderField("Nome", data?.BIN_NACIONAL?.PROPRIETARIO?.NOME)}
                </div>
              )}
            </div>
          )}
          <div>
            <h3>Informação Estadual</h3>
            {renderField("Marca/Modelo", data?.BIN_ESTADUAL?.MARCA_MODELO)}
            {renderField("Ano Fabricação/Modelo", data?.BIN_ESTADUAL?.ANO_FABRICACAO + '/' + data?.BIN_ESTADUAL?.ANO_MODELO)}
            {renderField("Categoria", data?.BIN_ESTADUAL?.CATEGORIA_VEICULO)}
            {renderField("Tipo veículo", data?.BIN_ESTADUAL?.TIPO_VEICULO)}
            {renderField("Placa", data?.BIN_ESTADUAL?.PLACA)}
            {renderField("Renavam", data?.BIN_ESTADUAL?.RENAVAM)}
            {renderField("Chassi", data?.BIN_ESTADUAL?.CHASSI)}
            {renderField("Situação", data?.BIN_ESTADUAL?.SITUACAO)}
            {renderField("Cambio", data?.BIN_ESTADUAL?.CAIXA_CAMBIO)}
            {renderField("Capacidade de carga", data?.BIN_ESTADUAL?.CAPACIDADE_CARGA)}
            {renderField("Cilindradas", data?.BIN_ESTADUAL?.CILINDRADA)}
            {renderField("CMT", data?.BIN_ESTADUAL?.CMT)}
            {renderField("Combustível", data?.BIN_ESTADUAL?.COMBUSTIVEL)}
            {renderField("Cor", data?.BIN_ESTADUAL?.COR_VEICULO)}
            {renderField("Espécie", data?.BIN_ESTADUAL?.ESPECIE_VEICULO)}
            {renderField("Emplacamento", data?.BIN_ESTADUAL?.DATA_EMPLACAMENTO)}
            {renderField("Município", data?.BIN_ESTADUAL?.MUNICIPIO)}
            {renderField("UF", data?.BIN_ESTADUAL?.UF)}
            {renderField("N. Carroceria", data?.BIN_ESTADUAL?.NUMERO_CARROCERIA)}
            {renderField("Número DI", data?.BIN_ESTADUAL?.NUMERO_DI)}
            {renderField("Data DI", data?.BIN_ESTADUAL?.DATA_REGISTRO_DI)}
            {renderField("Número Eixo Auxiliar", data?.BIN_ESTADUAL?.NUMERO_EIXO_AUXILIAR)}
            {renderField("Número Eixo Traseiro", data?.BIN_ESTADUAL?.NUMERO_EIXO_TRASEIRO)}
            {renderField("Quantidade Eixos", data?.BIN_ESTADUAL?.NUMERO_EIXOS)}
            {renderField("Número motor", data?.BIN_ESTADUAL?.NUMERO_MOTOR)}
            {renderField("PBT", data?.BIN_ESTADUAL?.PBT)}
            {renderField("Potência", data?.BIN_ESTADUAL?.POTENCIA_VEICULO)}
            {renderField("Procedência", data?.BIN_ESTADUAL?.PROCEDENCIA)}
            {renderField("Quantidade passageiros", data?.BIN_ESTADUAL?.QUANTIDADE_PASSAGEIROS)}
            {renderField("Situação chassi", data?.BIN_ESTADUAL?.SITUACAO_CHASSI)}
            {renderField("Tipo carroceria", data?.BIN_ESTADUAL?.TIPO_CARROCERIA)}
            {renderField("Tipo Doc. faturado", data?.BIN_ESTADUAL?.TIPO_DOCUMENTO_FATURADO)}
            {renderField("Tipo Doc. importador", data?.BIN_ESTADUAL?.TIPO_DOCUMENTO_IMPORTADOR)}
            {renderField("Número importador", data?.BIN_ESTADUAL?.NUMERO_IDENTIFICACAO_IMPORTADOR)}
            {renderField("Tipo Operação importação", data?.BIN_ESTADUAL?.TIPO_OPERACAO_IMPORTACAO_VEICULO)}
            {renderField("Montagem", data?.BIN_ESTADUAL?.TIPO_MONTAGEM)}
            {renderField("Número Faturado", data?.BIN_ESTADUAL?.NUMERO_IDENTIFICACAO_FATURADO)}
            {renderField("UF Faturamento", data?.BIN_ESTADUAL?.UF_FATURAMENTO)}
            {renderField("Data limite restrição trib.", data?.BIN_ESTADUAL?.DATA_LIMITE_RESTRICAO_TRIBUTARIA)}
            {renderField("Data atualização", data?.BIN_ESTADUAL?.DATA_ATUALIZACAO)}
            {renderField("Código órgão SRF", data?.BIN_ESTADUAL?.CODIGO_DO_ORGAO_SRF)}
            <Divider></Divider>
            {data?.BIN_ESTADUAL?.INFORMACOES_AVULSAS && data?.BIN_ESTADUAL?.INFORMACOES_AVULSAS.length > 0 && (
              <div>
                {data?.BIN_ESTADUAL?.INFORMACOES_AVULSAS.map((item: any) => (
                  renderField(item.DESCRICAO, item.VALOR)
                ))}
              </div>
            )}
            <h5>Restrições Estadual</h5>
            {data?.BIN_ESTADUAL?.RESTRICOES?.MENSAGENS_RESTRICOES && data?.BIN_ESTADUAL?.RESTRICOES?.MENSAGENS_RESTRICOES.length > 0 && (
              <div>
                {data?.BIN_ESTADUAL?.RESTRICOES?.MENSAGENS_RESTRICOES.map((item: any) => (
                  renderField("Restrição", item.MENSAGEM)
                ))}
              </div>
            )}
            <h5>Multas e débitos Estadual</h5>
            <TextField label="Débitos DPVAT" value={data?.BIN_ESTADUAL?.RESTRICOES?.DPVAT?.VALOR_PENDENCIA || 'NADA CONSTA'} />
            <TextField label="Débitos IPVA" value={data?.BIN_ESTADUAL?.RESTRICOES?.IPVA?.VALOR_PENDENCIA || 'NADA CONSTA'} />
            <TextField label="Débitos Licenciamento" value={data?.BIN_ESTADUAL?.RESTRICOES?.LICENCIAMENTO?.VALOR_PENDENCIA || 'NADA CONSTA'} />
            <TextField label="Débitos Multa" value={data?.BIN_ESTADUAL?.RESTRICOES?.MULTAS?.VALOR_PENDENCIA || 'NADA CONSTA'} />
          </div>
        </section>
      </Panel>

      <br />
      <br></br>
      {data?.GRAVAME && (
        <Panel header="Gravames">
          <DataTable value={data?.GRAVAME?.OCORRENCIAS}>
            <Column field="DATA_INCLUSAO_GRAVAME" header="Data"></Column>
            <Column field="PLACA" header="Placa"></Column>
            <Column field="RENAVAM" header="Renavam"></Column>
            <Column field="NOME_AGENTE" header="Informante"></Column>
            <Column field="DOC_AGENTE" header="Documento Informante"></Column>
            <Column field="NUMERO_CONTRATO" header="Contrato"></Column>
            <Column field="STATUS_VEICULO" header="Status veículo"></Column>
            <Column field="STATUS_GRAVAME" header="Status"></Column>
            <Column field="NOME_FINANCIADO" header="Nome Financiado"></Column>
            <Column field="DOC_FINANCIADO" header="Documento Financiado"></Column>
          </DataTable>
        </Panel>
      )}
      <br></br>
      {data?.RECALL && (
        <Panel header="Recall">
          <DataTable value={data?.RECALL?.OCORRENCIAS}>
            <Column field="DATA_INICIO" header="Data"></Column>
            <Column field="DEFEITO" header="Defeito"></Column>
            <Column field="MENSAGEM_COMPLETA" header="Mensagem"></Column>
            <Column field="RISCO" header="Risco"></Column>
          </DataTable>
        </Panel>
      )}
      <br></br>
      <Panel header="Ficha técnica">
        <h4>Informações técnicas</h4>
        <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
          <div>
            {renderField("Marca/Modelo", data?.FICHA_TECNICA_VEICULAR?.MARCA_MODELO)}
            {renderField("Ano Fabricação/Modelo", data?.FICHA_TECNICA_VEICULAR?.ANO_FABRICACAO + '/' + data?.FICHA_TECNICA_VEICULAR?.ANO_MODELO)}
            {renderField("Cor", data?.FICHA_TECNICA_VEICULAR?.COR_VEICULO)}
            {renderField("Número motor", data?.FICHA_TECNICA_VEICULAR?.NUMERO_MOTOR)}
            {renderField("Suspensão dianteira", data?.FICHA_TECNICA_VEICULAR?.SUSPENSAO_DIANTEIRA)}
            {renderField("Freio dianteira", data?.FICHA_TECNICA_VEICULAR?.FREIO_DIANTEIRO)}
            {renderField("Motor", data?.FICHA_TECNICA_VEICULAR?.MOTOR)}
            {renderField("Direção", data?.FICHA_TECNICA_VEICULAR?.DIRECAO)}
          </div>
          <div>
            {renderField("Placa", data?.FICHA_TECNICA_VEICULAR?.PLACA)}
            {renderField("Chassi", data?.FICHA_TECNICA_VEICULAR?.CHASSI)}
            {renderField("Combustível", data?.FICHA_TECNICA_VEICULAR?.COMBUSTIVEL)}
            {renderField("Suspensão traseira", data?.FICHA_TECNICA_VEICULAR?.SUSPENSAO_TRASEIRA)}
            {renderField("Freio traseiro", data?.FICHA_TECNICA_VEICULAR?.FREIO_TRASEIRO)}
            {renderField("Cambio", data?.FICHA_TECNICA_VEICULAR?.CAMBIO)}
            {renderField("Quantidade passageiros", data?.FICHA_TECNICA_VEICULAR?.QUANTIDADE_PASSAGEIROS)}
          </div>
        </section>
        <h4>Medidas</h4>
        <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
          <div>
            {renderField("Altura", data?.FICHA_TECNICA_VEICULAR?.MEDIDAS?.ALTURA)}
            {renderField("Comprimento", data?.FICHA_TECNICA_VEICULAR?.MEDIDAS?.COMPRIMENTO)}
            {renderField("Largura", data?.FICHA_TECNICA_VEICULAR?.MEDIDAS?.LARGURA)}
            {renderField("Entre eixos", data?.FICHA_TECNICA_VEICULAR?.MEDIDAS?.ENTRE_EIXOS)}
          </div>
          <div>
            {renderField("Peso", data?.FICHA_TECNICA_VEICULAR?.MEDIDAS?.PESO)}
            {renderField("Porta malas", data?.FICHA_TECNICA_VEICULAR?.MEDIDAS?.PORTA_MALAS)}
            {renderField("Tanque combustível", data?.FICHA_TECNICA_VEICULAR?.MEDIDAS?.TANQUE_COMBUSTIVEL)}

          </div>
        </section>
        <h4>Equipamentos</h4>
        <DataTable value={data?.FICHA_TECNICA_VEICULAR?.EQUIPAMENTOS}>
          <Column field="DESCRICAO" header="Descrição"></Column>
          <Column field="DISPONIBILIDADE" header="Disponibilidade"></Column>
        </DataTable>
      </Panel>
      <br></br>
      {data?.LEILAO && data?.LEILAO?.QUANTIDADE_OCORRENCIAS !== '0' && (
        <Panel header="Leilão">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              {renderField("Placa", data?.LEILAO?.DADOS_VEICULO?.PLACA)}
              {renderField("Categoria", data?.LEILAO?.DADOS_VEICULO?.CATEGORIA)}
              {renderField("Marca/Modelo", data?.LEILAO?.DADOS_VEICULO?.MARCA_MODELO)}
              {renderField("Motor", data?.LEILAO?.DADOS_VEICULO?.MOTOR)}
            </div>
            <div>
              {renderField("Chassi", data?.LEILAO?.DADOS_VEICULO?.CHASSI)}
              {renderField("Combustível", data?.LEILAO?.DADOS_VEICULO?.COMBUSTIVEL)}
              {renderField("Cor", data?.LEILAO?.DADOS_VEICULO?.COR)}
              {renderField("Ano Fabricação/Modelo", data?.LEILAO?.DADOS_VEICULO?.ANO_FABRICACAO + '/' + data?.LEILAO?.DADOS_VEICULO?.ANO_MODELO)}

            </div>
          </section>
          <DataTable value={data?.LEILAO?.OCORRENCIAS}>
            <Column field="DATA_LEILAO" header="Data"></Column>
            <Column field="LEILOEIRO" header="Leiloeiro"></Column>
            <Column field="LOTE" header="Lote"></Column>
            <Column field="COMITENTE" header="Comitente"></Column>
          </DataTable>
          {data?.LEILAO?.SCORE && (
            <div className="grid" style={{ gap: '5rem' }}>
              <div className="col">
                <h5>Score danos</h5>
                <Score score={getValueScore(data?.LEILAO?.SCORE?.PONTUACAO)} range={getRange(Number(getValueScore(data?.LEILAO?.SCORE?.PONTUACAO)))} />
              </div>
              <div className="col">
                <h5>Score referência</h5>
                <ScoreBarChart
                  score={data?.LEILAO?.SCORE?.PERCENTUAL_SOBRE_TABELA_REFERENCIA}
                  topMarkers={topMarkers}
                  bottomLabels={bottomLabels}
                  reverse={false}
                  maxScore={100}
                />
              </div>
              <div className="col">
                <h5>Score Aceitação</h5>
                <ScoreBarChart
                  score={data?.LEILAO?.SCORE?.ACEITACAO}
                  topMarkers={topMarkers}
                  bottomLabels={bottomLabels}
                  reverse={false}
                  maxScore={100}
                />
              </div>
            </div>

          )}

        </Panel>
      )}
      <br></br>
      {data?.LEILAO_CONJUGADO && (
        <div>
          {data?.LEILAO_CONJUGADO?.OCORRENCIAS.filter((i: any) => i.DADOS_VEICULO && i.DADOS_VEICULO.PLACA).map((item: any) => (

            <div>
              <Panel header={item.NOME_BASE}>
                <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                  <div>
                    {renderField("Placa", item.DADOS_VEICULO.PLACA)}
                    {renderField("Categoria", item.DADOS_VEICULO.CATEGORIA)}
                    {renderField("Marca/Modelo", item.DADOS_VEICULO.MARCA_MODELO)}
                    {renderField("Motor", item.DADOS_VEICULO.MOTOR)}
                  </div>
                  <div>
                    {renderField("Chassi", item.DADOS_VEICULO.CHASSI)}
                    {renderField("Combustível", item.DADOS_VEICULO.COMBUSTIVEL)}
                    {renderField("Cor", item.DADOS_VEICULO.COR)}
                    {renderField("Ano Fabricação/Modelo", item.DADOS_VEICULO.ANO_FABRICACAO + '/' + item.DADOS_VEICULO.ANO_MODELO)}

                  </div>
                </section>
                <DataTable value={item.OCORRENCIAS}>
                  <Column field="DATA_LEILAO" header="Data"></Column>
                  <Column field="LEILOEIRO" header="Leiloeiro"></Column>
                  <Column field="LOTE" header="Lote"></Column>
                  <Column field="COMITENTE" header="Comitente"></Column>
                </DataTable>
                {item.SCORE && (
                  <div className="grid" style={{ gap: '5rem' }}>
                    <div className="col">
                      <h5>Score danos</h5>
                      <Score score={getValueScore(item.SCORE.PONTUACAO)} range={getRange(Number(getValueScore(item.SCORE.PONTUACAO)))} />
                    </div>
                    <div className="col">
                      <h5>Score referência</h5>
                      <ScoreBarChart
                        score={item.SCORE.PERCENTUAL_SOBRE_TABELA_REFERENCIA}
                        topMarkers={topMarkers}
                        bottomLabels={bottomLabels}
                        reverse={false}
                        maxScore={100}
                      />
                    </div>
                    <div className="col">
                      <h5>Score Aceitação</h5>
                      <ScoreBarChart
                        score={item.SCORE.ACEITACAO}
                        topMarkers={topMarkers}
                        bottomLabels={bottomLabels}
                        reverse={false}
                        maxScore={100}
                      />
                    </div>
                  </div>

                )}

              </Panel>
              <br></br>
            </div>
          ))}
        </div>
      )}
      <br></br>
      {data?.CSV && (
        <Panel header="Laudo">
          <div className="grid">
            {data?.CSV?.OCORRENCIAS.map((item: any) => (
              <div className="col">
                {item.IMAGE_FILE ? (
                  <Image
                    src={'data:image/jpeg;base64, ' + item.IMAGE_FILE.FILE_BASE64}
                    alt="Image"
                    zoomSrc={'data:image/jpeg;base64, ' + item.IMAGE_FILE.FILE_BASE64}
                    preview
                    imageStyle={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <Image
                    src={pdfImagem}
                    alt="Image"
                    zoomSrc={pdfImagem}
                    preview
                    imageStyle={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                )}
                {item.PDF_FILE && (
                  <button
                    style={{
                      background: "transparent",
                      border: "none",
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: "blue",
                    }}
                    onClick={() => openPDF(item.PDF_FILE.FILE_BASE64)}
                  >
                    Abrir PDF
                  </button>
                )}
              </div>
            ))}
          </div>
        </Panel>
      )}
      <br></br>
      {data?.HISTORICO_ROUBO_FURTO && data?.HISTORICO_ROUBO_FURTO?.OCORRENCIAS && (
        <Panel header="Histórico de roubo/furto">
          <DataTable value={data?.HISTORICO_ROUBO_FURTO?.OCORRENCIAS}>
            <Column field="DATA_OCORRENCIA" header="Data"></Column>
            <Column field="BOLETIM" header="Boletim"></Column>
            <Column field="CHASSI" header="Chassi"></Column>
            <Column field="MARCA_MODELO" header="Marca/modelo"></Column>
            <Column body={(item: any) => item.ANO_FABRICACAO + '/' + item.ANO_MODELO} header="Ano Fabricação/modelo"></Column>
            <Column field="PLACA" header="Placa"></Column>
            <Column field="CIDADE" header="Cidade"></Column>
            <Column field="UF_OCORRENCIA" header="UF"></Column>
            <Column field="IDENTIDADE_INFORMANTE" header="RG"></Column>
            <Column field="TELEFONE_CONTATO" header="Telefone"></Column>
            <Column field="NOME_INFORMANTE" header="Informante"></Column>

          </DataTable>
        </Panel>
      )}
      <br></br>
      {data?.INDICIO_SINISTRO && data?.INDICIO_SINISTRO?.INDICIO_SINISTRO !== '0' && (
        <Panel header="Indício de sinistro">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              {renderField("Descrição", data?.INDICIO_SINISTRO?.DESCRICAO_OCORRENCIA)}

            </div>
            <div>
              {renderField("Existe ocorrência", data?.INDICIO_SINISTRO?.EXISTE_OCORRENCIA)}


            </div>
          </section>
        </Panel>
      )}
      <br></br>
      {data?.ALERTA_VEICULAR_PROPRIEDADE && data?.ALERTA_VEICULAR_PROPRIEDADE?.QUANTIDADE_OCORRENCIAS !== '0' && (
        <Panel header="Alerta Veicular Propriedade">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              {renderField("Chassi", data?.ALERTA_VEICULAR_PROPRIEDADE?.CHASSI)}
            </div>
            <div>
              {renderField("Placa", data?.ALERTA_VEICULAR_PROPRIEDADE?.PLACA)}
            </div>
          </section>
          {data?.ALERTA_VEICULAR_PROPRIEDADE?.OCORRENCIAS && data?.ALERTA_VEICULAR_PROPRIEDADE?.OCORRENCIAS.length > 0 && (
            <DataTable value={data?.ALERTA_VEICULAR_PROPRIEDADE?.OCORRENCIAS}>
              <Column field="DESCRICAO" header="Descrição"></Column>
              <Column field="DATA" header="Data"></Column>
            </DataTable>
          )}
        </Panel>
      )}
      <br></br>
      {data?.AGREGADOS && data?.AGREGADOS?.REGISTROS && data?.AGREGADOS?.REGISTROS.length > 0 && (
        <Panel header="Agregados">
          {data?.AGREGADOS?.DESCRICAO_AGREGADO && (
            renderField("Descrição", data?.AGREGADOS?.DESCRICAO_AGREGADO)
          )}
          {data?.AGREGADOS?.REGISTROS.map((item: any, index: number) => (
            <div key={index}>
              <Panel header={`Registro ${index + 1} - ${item.MARCA_MODELO || ''}`}>
                <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                  <div>
                    {renderField("Marca/Modelo", item.MARCA_MODELO)}
                    {renderField("Tipo de Veículo", item.TIPO_DE_VEICULO)}
                    {renderField("Chassi", item.CHASSI)}
                    {renderField("Placa", item.PLACA)}
                    {renderField("Renavam", item.RENAVAM)}
                    {renderField("Ano Fabricação/Modelo", item.ANO_DE_FABRICACAO + '/' + item.ANO_MODELO)}
                    {renderField("Cor", item.COR)}
                    {renderField("Combustível", item.COMBUSTIVEL)}
                    {renderField("Potência", item.POTENCIA)}
                    {renderField("Cilindrada", item.CILINDRADA)}
                  </div>
                  <div>
                    {renderField("Espécie", item.ESPECIE)}
                    {renderField("Situação do Chassi", item.SITUACAO_DO_CHASSI)}
                    {renderField("UF da Placa", item.UF_DA_PLACA)}
                    {renderField("Município", item.MUNICIPIO)}
                    {renderField("Procedência", item.PROCEDENCIA)}
                    {renderField("Número do Motor", item.NUMERO_DO_MOTOR)}
                    {renderField("PBT", item.PBT)}
                    {renderField("CMT", item.CMT)}
                    {renderField("Quantidade Passageiros", item.QUANTIDADE_DE_PASSAGEIROS)}
                    {renderField("Data Atualização", item.DATA_ATUALIZACAO)}
                  </div>
                </section>
              </Panel>
              <br></br>
            </div>
          ))}
        </Panel>
      )}
      <br></br>
      {data?.VEICULOS_POR_DOCUMENTO && data?.VEICULOS_POR_DOCUMENTO?.QUANTIDADE_OCORRENCIAS !== '0' && (
        <Panel header="Veículos por Documento">
          {data?.VEICULOS_POR_DOCUMENTO?.OBSERVACAO && (
            renderField("Observação", data?.VEICULOS_POR_DOCUMENTO?.OBSERVACAO)
          )}
          {data?.VEICULOS_POR_DOCUMENTO?.OCORRENCIAS && data?.VEICULOS_POR_DOCUMENTO?.OCORRENCIAS.length > 0 && (
            <DataTable value={data?.VEICULOS_POR_DOCUMENTO?.OCORRENCIAS}>
              <Column field="PLACA" header="Placa"></Column>
              <Column field="CHASSI" header="Chassi"></Column>
              <Column field="MARCA_MODELO" header="Marca/Modelo"></Column>
              <Column field="ANO_FABRICACAO" header="Ano Fabricação"></Column>
              <Column field="ANO_MODELO" header="Ano Modelo"></Column>
              <Column field="COR" header="Cor"></Column>
            </DataTable>
          )}
        </Panel>
      )}
    </Panel>
  )
}